import React, { Component } from 'react';
import history, { gotoPage } from './history';
// styles
import 'material-components-web/dist/material-components-web.min.css';
import './app.css';
// ui
import { SimpleTopAppBar } from 'rmwc/TopAppBar';
import { Drawer, DrawerContent } from 'rmwc/Drawer';
import { List, ListItem, ListItemGraphic } from 'rmwc/List';
// pages
import Home from './pages/Home';
import TheSoldiers from './pages/TheSoldiers';
import AboutTheProject from './pages/AboutTheProject';
import AboutTheWar from './pages/AboutTheWar';
// comps
import BreadcrumbTrail from './components/BreadcrumbTrail';
import RadioCumbria from "./pages/RadioCumbria";
import Footer from "./components/Footer";
import LabelGenerator from './LabelGenerator';

const pages = {
    home: {
        path: 'home',
        name: 'Home'
    },
    theFallen: {
        path: 'theFallen',
        name: 'The Fallen'
    },
    ww1: {
        path: 'ww1',
        name: 'About WW1'
    },
    project: {
        path: 'project',
        name: 'About the project'
    },
    bbcRadioCumbria: {
        path: 'bbcRadioCumbria',
        name: 'BBC Radio Cumbria'
    }
};

class App extends Component {

    constructor(props) {
        super(props);

        this.state = { unlisten: null, page: 'home', activeTabIndex: 0, navigationOpen: false };

        this.onNavigationClick = this.onNavigationClick.bind(this);
        this.setPageData = this.setPageData.bind(this);
    }

    componentDidMount() {
        // set up routing
        const location = history.location;
        const unlisten = history.listen((location) => {
            this.setPageData(location.pathname);
        });
        
        this.setPageData(location.pathname, location.search);

        this.setState({ unlisten: unlisten });
    }

    componentWillUnmount() {
        this.state.unlisten();
    }

    setPageData(fullPath, search) {
        let page;

        if (fullPath === '/') {
            page = 'home';
        }
        else {
            page = fullPath.split('/').join("");
        }

        const route = pages[page] ? pages[page] : pages.home;
        this.setState({ page, pageName: route.name, search });
        window.scrollTo(0, 0);
    }

    onNavigationClick(page) {

        const route = pages[page] ? pages[page] : pages.home;

        this.setState({ navigationOpen: false, pageName: route.name, page });
        gotoPage(page);
    }

    render() {
        const { page, pageName, search } = this.state;
        if(search && search.indexOf('showlabels') > -1){
            return <LabelGenerator />
        }

        return (
            <div className="app">

                <SimpleTopAppBar
                    style={{ backgroundColor: '#303030', zIndex: 9998 }}
                    title={pageName}
                    fixed={true}
                    navigationIcon={{ onClick: () => this.setState({ navigationOpen: !this.state.navigationOpen }) }}
                />

                <Drawer
                    modal
                    style={{ zIndex: 9999 }}
                    open={this.state.navigationOpen}
                    onClose={() => this.setState({ navigationOpen: false })}>
                    {/*<DrawerHeader>
                        <DrawerTitle>DrawerHeader</DrawerTitle>
                        <DrawerSubtitle>Subtitle</DrawerSubtitle>
                    </DrawerHeader>*/}
                    <DrawerContent>
                        <List>
                            <ListItem onClick={() => this.onNavigationClick('home')}>
                                <ListItemGraphic icon={'home'}/>
                                Home
                            </ListItem>
                            <ListItem onClick={() => this.onNavigationClick('theFallen')}>
                                <ListItemGraphic icon={'add_location'}/>
                                The Fallen
                            </ListItem>
                            <ListItem onClick={() => this.onNavigationClick('ww1')}>
                                <ListItemGraphic icon={'book'}/>
                                About WW1
                            </ListItem>
                            <ListItem onClick={() => this.onNavigationClick('project')}>
                                <ListItemGraphic icon={'info'}/>
                                About the project
                            </ListItem>
                            <ListItem onClick={() => this.onNavigationClick('bbcRadioCumbria')}>
                                <ListItemGraphic icon={'radio'}/>
                                BBC Radio Cumbria
                            </ListItem>
                        </List>
                    </DrawerContent>
                </Drawer>

                {/*<DataGenerator/>*/}

                <div className={'app--content'}>

                    <BreadcrumbTrail pageName={pageName}/>

                    {page === 'home' &&
                    <Home/>
                    }

                    {page === 'theFallen' &&
                    <TheSoldiers/>
                    }

                    {page === 'project' &&
                    <AboutTheProject/>
                    }

                    {page === 'ww1' &&
                    <AboutTheWar/>
                    }

                    {page === 'bbcRadioCumbria' &&
                    <RadioCumbria/>
                    }
                </div>

                <Footer/>


            </div>

        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/app/App.js